import { createSelector } from 'reselect';

const selectCustomerNotSelected = (state) => state.setup_advanced_user_customer_not_selected;

export const selectCustomersNotSelected = createSelector(
  [selectCustomerNotSelected],
  (customerNotSelected) => customerNotSelected.customer_not_selected,
);
